/** No persisted City Insights row for the visited city — generation requested. */
export const LOCAL_FOCUS_CITY_INSIGHTS_GENERATION_TRIGGERED =
  'local_focus_city_insights_generation_triggered' as const;

/** No S3 image for an Area Card neighbourhood — generation requested. */
export const LOCAL_FOCUS_NEIGHBOURHOOD_IMAGE_GENERATION_TRIGGERED =
  'local_focus_neighbourhood_image_generation_triggered' as const;

/** No S3 hero image for the resolved city — generation requested. */
export const LOCAL_FOCUS_HERO_IMAGE_GENERATION_TRIGGERED =
  'local_focus_hero_image_generation_triggered' as const;

export const LOCAL_FOCUS_CONTENT_TYPE = {
  CITY_INSIGHTS: 'city_insights',
  NEIGHBOURHOOD_IMAGE: 'neighbourhood_image',
  HERO_IMAGE: 'hero_image',
} as const;
